const NOTES_KEY = 'notes';

const notesKeys = {
  all: (schoolyearId: string, schoolId: string) =>
    [schoolyearId, schoolId, NOTES_KEY] as const,
};

export default notesKeys;
